<div class="dynabot-knowledge-page container-fluid">
  <mat-card appearance="outlined">
    <mat-card-content>
      <message-box type="warn" title="Prototype only">
        <p>DynaBot is a prototype. Its answers can be wrong or incomplete and must not be relied on for credit or any other decision.</p>
      </message-box>

      <message-box type="info" title="DynaBot context">
        <p>These files are added to DynaBot's instructions. Saved changes apply to the next DynaBot chat that is started; chats already open keep the context they started with.</p>
        <p>Files are saved on this API server, so they reset to the committed versions when the API is redeployed. Text inside &lt;!-- --&gt; comments is not sent to DynaBot.</p>
      </message-box>

      <div class="layout">
        <div class="file-list">
          <div class="file-list-header">
            <span class="mat-h3">Context files</span>
            <button mat-stroked-button color="primary" (click)="onNewFile()">New file</button>
          </div>
          <mat-nav-list>
            @for (file of files; track file.fileName) {
              <a mat-list-item [activated]="file.fileName === selectedFileName" (click)="onSelectFile(file)">
                <span matListItemTitle>{{ file.title }}</span>
                <span matListItemLine>{{ file.fileName }} · {{ file.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
              </a>
            }
            @if (isNewFile) {
              <a mat-list-item [activated]="true">
                <span matListItemTitle>New file</span>
                <span matListItemLine>{{ formControlFileName.value || 'Not saved yet' }}</span>
              </a>
            }
          </mat-nav-list>
        </div>

        <form class="editor" [formGroup]="formGroup" (ngSubmit)="onSave()">
          <mat-form-field class="file-name">
            <mat-label>File name</mat-label>
            <input matInput [formControl]="formControlFileName" placeholder="lending-faq.md">
            <mat-hint>Lowercase letters, numbers and hyphens, ending in .md</mat-hint>
            @if (formControlFileName.hasError('required')) {
              <mat-error>File name is required</mat-error>
            } @else if (formControlFileName.hasError('taken')) {
              <mat-error>This file already exists. Select it in the list to edit it.</mat-error>
            } @else if (formControlFileName.hasError('maxlength')) {
              <mat-error>File name is too long</mat-error>
            } @else if (formControlFileName.hasError('pattern')) {
              <mat-error>Use lowercase letters, numbers and hyphens, ending in .md</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="content">
            <mat-label>Content (Markdown)</mat-label>
            <textarea matInput [formControl]="formControlContent" rows="24"></textarea>
            <mat-hint align="end">{{ formControlContent.value.length }} / {{ maxContentLength }}</mat-hint>
            @if (formControlContent.hasError('maxlength')) {
              <mat-error>Content is longer than {{ maxContentLength }} characters</mat-error>
            }
          </mat-form-field>

          <div class="actions">
            <button mat-stroked-button type="button" [disabled]="!formGroup.dirty" (click)="onDiscard()">Discard changes</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="formGroup.invalid || !formGroup.dirty">Save</button>
          </div>
        </form>
      </div>
    </mat-card-content>
  </mat-card>
</div>
